import { Box, Center, Spinner, SpinnerProps } from '@chakra-ui/react';

export const Loader = ({ size = 'lg', ...rest }: SpinnerProps) => {
  return (
    <Box pos="absolute" inset="0" data-testid="loader">
      <Center h="full">
        <Spinner size={size} {...rest} />
      </Center>
    </Box>
  );
};
